import { debug } from '../lib/debug';

const processEnv =
  typeof globalThis !== 'undefined' &&
  'process' in globalThis &&
  globalThis.process
    ? globalThis.process.env
    : undefined;

export const DEBUG_MODE = localStorage.getItem('DEBUG_MODE') === 'true';
export const DEBUG_SENTRY_MODE =
  localStorage.getItem('DEBUG_MODE_SENTRY') === 'true';
// QA override: force the Happydesk chat branch on any cluster/env (e.g. local, non-ru staging)
export const FORCE_HAPPYDESK =
  localStorage.getItem('forceHappydesk') === 'true';
// QA override: force the RU About Diagnocat labeling on any cluster/env (e.g. local, non-ru staging)
export const FORCE_RU_LABELING =
  localStorage.getItem('forceRuLabeling') === 'true';

const LOCALHOST_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]']);

const resolveBaseURI = () => {
  const configuredBaseURI = __REACT_APP_ROOT_URI__ || __REACT_APP_BASE_URI__;

  if (!configuredBaseURI) {
    return window.location.origin;
  }

  try {
    const configuredURL = new URL(configuredBaseURI);

    if (
      LOCALHOST_HOSTNAMES.has(configuredURL.hostname) &&
      !LOCALHOST_HOSTNAMES.has(window.location.hostname)
    ) {
      return window.location.origin;
    }
  } catch {
    return window.location.origin;
  }

  return configuredBaseURI;
};

debug({
  env: import.meta.env,
  'process.env': processEnv,
  REACT_APP_AVAILABLE_LANGS: __REACT_APP_AVAILABLE_LANGS__,
  REACT_APP_BASE_URI: __REACT_APP_BASE_URI__,
  REACT_APP_ROOT_URI: __REACT_APP_ROOT_URI__,
  REACT_APP_BASE_URI_BLACK_CAT: __REACT_APP_BASE_URI_BLACK_CAT__,
  REACT_APP_CORS_POLICY: __REACT_APP_CORS_POLICY__,
  REACT_APP_CLUSTER: __REACT_APP_CLUSTER__,
  REACT_APP_KB_BASE_URL: __REACT_APP_KB_BASE_URL__,
  APP_VERSION: __APP_VERSION__,
});

export const BASE_URI = resolveBaseURI();
export const ENVIRONMENT = import.meta.env.MODE || 'development';
export const APP_VERSION = __APP_VERSION__;
export const IS_DEVELOP_FEATURE = ENVIRONMENT === 'development';
export const BASE_URI_BLACK_CAT = __REACT_APP_BASE_URI_BLACK_CAT__;

// sentry variables
export const SENTRY_DSN = __REACT_APP_SENTRY_DSN__ || '';
export const SENTRY_TRACES_SAMPLE_RATE =
  parseFloat(__REACT_APP_SENTRY_TRACE_RATE__) || 0.2;
export const SENTRY_PROFILES_SAMPLE_RATE =
  parseFloat(__REACT_APP_SENTRY_PROFILES_SAMPLE_RATE__) || 1.0;
export const ERROR_TRACKING_ENABLED_ENVIRONMENTS = ['production', 'staging'];
export const IS_ERROR_TRACKING_ENABLED =
  ERROR_TRACKING_ENABLED_ENVIRONMENTS.includes(ENVIRONMENT);

// Faro Web SDK configuration
export const FARO_URL_BASE = __REACT_APP_FARO_URL_BASE__ || '';
export const FARO_API_KEY = __REACT_APP_FARO_API_KEY__ || '';
export const FARO_ENABLED_ENVIRONMENTS = [
  'production',
  'staging',
  'development',
];
export const IS_FARO_ENABLED =
  FARO_ENABLED_ENVIRONMENTS.includes(ENVIRONMENT) &&
  Boolean(FARO_URL_BASE) &&
  Boolean(FARO_API_KEY);

export const CORS_POLICY =
  (__REACT_APP_CORS_POLICY__ as RequestCredentials) || 'same-origin';

// PostHog analytics (optional). All PostHog traffic goes through the gate's
// first-party /ph proxy, so the browser always uses the Diagnocat origin and
// never the PostHog host.
export const POSTHOG_API_HOST = '/ph';
export const POSTHOG_TOKEN = __REACT_APP_POSTHOG_TOKEN__ || '';
export const IS_POSTHOG_ENABLED = Boolean(POSTHOG_TOKEN);

export const CLUSTER = __REACT_APP_CLUSTER__;
export const KB_BASE_URL = __REACT_APP_KB_BASE_URL__ || '';
export const ONBOARDING_TOKEN = __REACT_APP_ONBOARDING_TOKEN__ || '';

// Single source of truth for which chat runs: Happydesk on the CIS cluster, or
// anywhere when QA forces it. ChatRoutes and useLogout must agree on this, so
// the widget is both mounted and torn down under the same condition.
export const IS_HAPPYDESK_CHAT = CLUSTER === 'ru' || FORCE_HAPPYDESK;
